module.exports = __webpack_public_path__ + "img/img_icon_109.cfd78c77.png";